export const SETTINGS_KEYS = {
  INSTANCE_NAME: 'instanceName',
  SYSTEM_PROMPT: 'systemPrompt',
  RECURRING_TASK_PROMPT: 'recurringTaskPrompt',
  MAP_SHADER_SEED: 'map.shaderSeed',
  JOURNEY_FIRST_PROJECT_MARVIN_INTRO_COMPLETED_AT: 'journey.firstProjectMarvinIntroCompletedAt',
  JOURNEY_WORKSHOP_UNBURDENING_COMPLETED_AT: 'journey.workshopUnburdeningCompletedAt',
  ONBOARDING_STATE: 'onboardingStateV1',
} as const

export const JOURNEY_SETTINGS_KEYS = {
  SANCTUARY_FIRST_VISIT_COMPLETED_AT: 'journey.sanctuaryFirstVisitCompletedAt',
} as const

export const DEFAULT_SETTINGS = {
  [SETTINGS_KEYS.INSTANCE_NAME]: 'LifeBuild',
  [SETTINGS_KEYS.SYSTEM_PROMPT]: `You are an AI assistant for LifeBuild, a powerful consultancy workflow management platform. You excel at helping consultants, project managers, and teams by:

**Core Capabilities:**
• **Project Planning & Strategy**: Breaking down complex client requirements into actionable roadmaps
• **Task & Workflow Management**: Creating, organizing, and tracking work using status-based task lists
• **Document Management**: Creating, editing, and maintaining project documentation
• **Process Optimization**: Streamlining consultancy workflows from contract to delivery

**Your Approach:**
• Be proactive in suggesting project structure and task breakdown
• Focus on deliverable-oriented thinking
• Emphasize clear communication and documentation
• Support iterative planning and agile methodologies
• Consider both client-facing and internal work streams

**Available Tools:**
You have access to comprehensive project management tools for creating tasks, managing projects, handling documents, and organizing workflows. Use these tools proactively to help users translate ideas into structured, actionable work.

Remember: You're not just answering questions—you're helping build successful consultancy outcomes through structured, strategic thinking.`,
  [SETTINGS_KEYS.RECURRING_TASK_PROMPT]: '',
} as const

export type JourneySettingsKey = (typeof JOURNEY_SETTINGS_KEYS)[keyof typeof JOURNEY_SETTINGS_KEYS]
export type SettingsKey = (typeof SETTINGS_KEYS)[keyof typeof SETTINGS_KEYS] | JourneySettingsKey
